export const AI_CHECKIN_TOGGLE_MIC_EVENT = "floline:ai-checkin:toggle-mic";
export const AI_CHECKIN_MIC_STATUS_EVENT = "floline:ai-checkin:mic-status";

export type AiCheckInMicStatus = {
  isRecording: boolean;
  isTranscribing: boolean;
  isAvailable: boolean;
};

export function dispatchAiCheckInToggleMic() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AI_CHECKIN_TOGGLE_MIC_EVENT));
}

export function dispatchAiCheckInMicStatus(status: AiCheckInMicStatus) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<AiCheckInMicStatus>(AI_CHECKIN_MIC_STATUS_EVENT, {
      detail: status,
    })
  );
}
